export default
{
    name     : process.env.REACT_APP_NAME ,
    homepage : process.env.REACT_APP_HOMEPAGE ,
    home     : '/' ,
    timeout  : process.env.REACT_APP_TIMEOUT ,

    // storages

    referrer : 'referrer' ,
    cache :
    {
        get : '_cache_get'
    } ,

    // debug

    debug   : process.env.NODE_ENV === 'development' ,
    verbose : process.env.REACT_APP_VERBOSE === 'true' ,

    // metadatas

    helmet :
    {
        defaultTitle  : "TALE - Chaque récit est un voyage" ,
        titleTemplate : 'TALE - %s' ,
        metas         :
        [
            { charSet : 'utf-8'} ,

            { name : 'description' ,  content : 'Tale, Chaque récit est un voyage.' } ,
            { name : 'keywords'    ,  content : 'map,tale,tales,carte,contes,voyage,récit,histoire' } ,

            { property : "og:type" , content : 'article' }
        ]
    }
} ;


// WEBPACK FOOTER //
// ./src/app/configs/config.js